<template>
  <Container type="card-full">
    <div slot="header">
      <el-button v-if="type === 1 || type === 2 ||  type === 4" @click="save" :loading="btnLoading">保存</el-button>
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
    </div>
    <div>
    <div class="main">
      <el-form :model="expert" ref="ruleForm" label-position="right" class="mainfrom from_input">
        <div class="row">
            <el-form-item label="姓名" prop="expertname" verify>
              <el-input v-model="expert.expertname" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="expertsex">
              <el-select v-model="expert.expertsex" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in sexList"  :key="item.index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
        </div>
        <div class="row">
            <el-form-item label="证件类型" prop="expertidtype" verify>
              <el-select v-model="expert.expertidtype" placeholder="请选择" :disabled="disable">
                <el-option v-for="item in expertidtypeList"  :key="item.index" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="证件编号"  prop="expertidcode" :verify="validateExpertidcode">
              <el-input v-model="expert.expertidcode" :maxlength="30" :disabled="disable"></el-input>
            </el-form-item>
        </div>

            <el-form-item label="手机号码" prop="expertmobile" verify>
              <el-input v-model="expert.expertmobile" :maxlength="20" :disabled="disable"></el-input>
            </el-form-item>
        <div class="row">
            <el-form-item label="银行名称">
              <el-input v-model="expert.expertbankname" :maxlength="50" :disabled="disable"></el-input>
            </el-form-item>

            <el-form-item label="银行卡账号">
              <el-input v-model="expert.expertbankcode" :maxlength="50" :disabled="disable"></el-input>
            </el-form-item>
        </div>
      </el-form>
    </div>
      <vggrid ref="xGrid" :list="list" tableheight="300" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
              @cellClick="cellClick"
          :isOperate="isOperate" :operateBtn="operateBtn" @vggridClick="vggridClick"
              >
          <template slot="btn">
            <div class="btn-box">
              <vxe-button type="text" icon='vxe-icon--plus' v-if="type === 1 || type === 2 ||  type === 4" @click="addAppend" :loading="btnLoading">新增</vxe-button>
            </div>
          </template>
      </vggrid>
      <!-- 弹窗 -->
      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose">
        <div class="addexport">
          <el-form :model="appendItem" ref="ruleAppend" label-position="right"  class="mainfrom from_input">
            <div class="row">
                  <el-form-item label="顺序号">
                    <el-input v-model="appendItem.appendseq" :maxlength="4" :disabled="disable"></el-input>
                  </el-form-item>

                  <el-form-item label="附件类型" prop="appendtype" verify>
                    <el-select v-model="appendItem.appendtype" :clearable="true" :disabled="disable">
                      <el-option v-for="(item, index) in appendTypeList" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
            </div>
              <div class="row">
                  <el-form-item label="附件编号">
                    <el-input v-model="appendItem.appendfilecode" :maxlength="128" show-word-limit :disabled="disable"></el-input>
                  </el-form-item>

                  <el-form-item label="附件名称" prop="appendfilename" verify>
                    <el-input v-model="appendItem.appendfilename" :maxlength="128" show-word-limit :disabled="disable"></el-input>
                  </el-form-item>
              </div>
              <el-form-item label="URL" prop="appendurl" verify>
                <upload-pic-one @changed="setPic" :picUrl="appendItem.appendurl" folderName="web" text="选择文件"></upload-pic-one>
              </el-form-item>
            </el-form>
            <div style="overflow:hidden">
              <el-button @click="saveAppend" style="float:right;margin-right:20px;">确定</el-button>
            </div>
        </div>
      </el-dialog>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import Md5 from '../../assets/js/md5'
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import uploadPicOne from '../common/uploadPicOne'
  const SUCCESS = 1
  export default {
    name: "expertform",
    mixins: [common],
    data () {
      return {
        expert: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'appendtypeCN', fieldtype: 'C', title: '附件类型',calculExpr:''},
          { field: 'appendfilecode', fieldtype: 'C',title: '文件编号',calculExpr:''},
          { field: 'appendfilename', fieldtype: 'C',title: '文件名',calculExpr:''},
          // { field: 'appendurl', fieldtype: 'C',title: 'URL',calculExpr:''}
        ],
        isOperate:true,
        operateBtn:[
          {btncode:'CHG',btnicon:'el-icon-edit-outline',btnname:'修改'},
          {btncode:'DEL',btnicon:'el-icon-delete',btnname:'删除'}
        ],
        append: {},
        list: [],
        sexList: [],
        expertidtypeList: [],
        appendTypeList:[],
        appendItem:{},
        dialogVisible: false,
      }
    },
    activated () {
      this.init()
      this.getSexList()
      this.getIdtypeList()
      // this.getAppendType()
      this.getList()
    },
    created () {
      this.$on('CHG', () => this.chgAppend())
      this.$on('DEL', () => this.delAppend())
    },
    watch: {
    },
    filters: {
    },
    components: {vggrid,uploadPicOne},
    computed: {
      uploadAddr() {
        return this.$store.getters.uploadAddr
      },
    },
    methods: {
      validateExpertidcode (rul, val, callback) {
        // console.log('val',val);

        this.expert.expertidcode = _.trim(val)
        this.validateData('评审人证件已注册','expertrec','expertid','expertidcode', val, callback)
      },
      validateData (msg,tablename,fieldid,checkfield, checkval, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename,fieldid, checkfield, checkval: this.expert[checkfield], id: this.expert.expertid}
        }).then (res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      async init() {
        this.type = Number(this.$route.params.type),
        this.disable = this.$route.params.type === 3 ? true : false
        this.expert = this.$route.params.form
        this.sexList = []
        this.expertidtypeList = []
        this.append = {}
        this.list = []
        this.appendTypeList = []
        this.appendItem = {}
      },
      async getSexList () {
        this.sexList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode:'sex'}
        })
      },
      async getIdtypeList () {
        this.expertidtypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode:'expertidtype'}
        })
      },
      vggridClick(code,row){
        this.append = row
        this.$emit(code,row)
      },
      async cellClick (row) {
        this.append = row.row
      },
      async getList() {
        this.appendTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode:'appendtype'}
        })
        if(this.appendTypeList){
          this.list = await request({
            url: '/ywgl/append/getPageList',
            method: "get",
            params: {appendfromid: this.expert.expertid,appendfromtype: 3}
          })
          for(let i = 0;i <this.list.length;i++){
            for(let j = 0;j < this.appendTypeList.length;j++){
              if(this.list[i].appendtype == this.appendTypeList[j].syscodeseq){
                this.list[i].appendtypeCN = this.appendTypeList[j].label
                console.log('this.appendTypeList[j].label',this.appendTypeList[j].label)
              }
            }
          }
        }
      },
      async addAppend () {
        let i = 1
        this.list.forEach(item => {
          if (item.appendseq >= i) {
            i = item.appendseq + 1
          }
        })
        this.appendid = 0;  //判断是否新增
        this.appendfromid=this.expert.expertid,
        this.appendItem.appendfromtype= '3',
        this.appendItem.appendseq= i,
        this.appendItem.returnForm= 'expertForm'
        this.dialogVisible = true
      },
      async chgAppend () {
        if (!this.append.id) {
          this.$message.warning('请选择一行!')
          return
        }
        this.appendItem = _.cloneDeep(this.append);
        this.dialogVisible = true
      },
      async delAppend () {
        if (!this.append.id) {
          this.$message.warning('请选择一行!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          this.appendItem = _.cloneDeep(this.append);
          this.list.forEach((key,index)=>{
            this.list.forEach((key,index)=>{
                if(key.id === this.appendItem.id){
                  this.list.splice(index,1)
                }
              })
          })
          this.appendItem = {}
        })
      },
      async save () {
        this.submitForm('ruleForm').then(async() => {
          this.expert.expertstatus = '2'
          this.expert.appendfromtype = 3
          this.expert.list = this.list
          let data = await request({
            url: '/ywgl/expert/addOrEdit',
            method: "post",
            data: this.expert
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'expertIndex'})
      },
      async getAppendType() {
        this.appendTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode:'appendtype'}
        })
      },
      async handleClose(done) {
        this.appendItem = {}
        this.dialogVisible = false
      },
      async setPic  (path) {
          this.$set(this.appendItem,'appendurl',path.replace(this.uploadAddr,''))
      },
      async saveAppend(){
        this.appendTypeList.forEach(key => {
          if(key.syscodeseq == this.appendItem.appendtype){
            this.appendItem.appendtypeCN = key.label
          }
        })
        this.submitForm('ruleAppend').then(async() => {
          if(this.appendItem.id){
            this.list.forEach((key,index)=>{
              if(key.id === this.appendItem.id){
                this.list.splice(index,1,this.appendItem)
              }
            })
          }
          else{
            this.list.push(this.appendItem)
          }
          this.dialogVisible = false
          this.append = this.appendItem
          this.appendItem = {}
        }).catch(() => {})
      }
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    margin-bottom: 50px;
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    content .el-textarea__inner, .el-textarea {
      width: 840px;
    }
  }
  .btn-box{
  overflow: hidden;
    .vxe-button{
      padding: 10px 10px;
      font-size: 16px;
    }
  }
</style>
